import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Trophy } from 'lucide-react';
import { cupLabel } from '../../lib/cupProgressLabels';

export const CupProgressWidget = ({ cupProgress, user }) => {
  const userLabels = user?.cup_progress_labels;
  return (
  <div className="h-full" data-testid="cup-progress">
    <div className="flex flex-row items-center justify-between pb-4">
      <h3 className="text-xl font-semibold font-title">Cup Progress</h3>
      <Link to="/matches">
        <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
          View All
        </Button>
      </Link>
    </div>
    <div className="bg-white rounded-2xl p-4" style={{ border: '1px solid #e5e2dc' }}>
      {cupProgress.length > 0 ? (
        <div className="space-y-3">
          {cupProgress.map((cup, index) => {
            const totalRounds = cup.wins + cup.losses;
            const isEliminated = cup.status === 'eliminated';
            const isWon = cup.status === 'won';
            const wrapBg = isWon ? 'bg-amber-50' : (isEliminated ? 'bg-gray-50' : 'bg-emerald-50');
            const wrapBorder = isWon ? '#fde68a' : (isEliminated ? '#e5e5e5' : '#d1fae5');
            const trophyColor = isWon ? 'text-amber-500' : (isEliminated ? 'text-gray-400' : 'text-emerald-600');
            const badgeClass = isWon
              ? 'bg-amber-100 text-amber-700'
              : (isEliminated ? 'bg-red-100 text-red-600' : 'bg-emerald-100 text-emerald-600');
            const badgeText = isWon
              ? cupLabel(userLabels, 'winner_badge', cup.latest_round)
              : (isEliminated
                ? cupLabel(userLabels, 'eliminated_badge', cup.latest_round)
                : cupLabel(userLabels, 'active_badge', cup.latest_round));
            const barFillClass = isWon ? 'bg-amber-500' : (isEliminated ? 'bg-gray-400' : 'bg-emerald-500');
            const footerText = isWon
              ? cupLabel(userLabels, 'winner_footer', cup.latest_round)
              : (isEliminated
                ? cupLabel(userLabels, 'eliminated_footer', cup.latest_round)
                : cupLabel(userLabels, 'active_footer', cup.latest_round));
            
            return (
              <div 
                key={index} 
                className={`p-3 rounded-xl ${wrapBg}`}
                style={{ border: `1px solid ${wrapBorder}` }}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Trophy className={`w-5 h-5 ${trophyColor}`} strokeWidth={1.5} />
                    <span className="font-medium text-gray-900">{cup.name}</span>
                  </div>
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${badgeClass}`}>
                    {badgeText}
                  </span>
                </div>
                
                {/* Progress bar */}
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div 
                      className={`h-full ${barFillClass}`}
                      style={{ width: `${isWon ? 100 : (totalRounds > 0 ? (cup.wins / totalRounds) * 100 : 0)}%` }}
                    />
                  </div>
                  <span className="text-xs text-gray-500 whitespace-nowrap">
                    {cup.wins}W {cup.losses}L
                  </span>
                </div>
                
                {/* Latest round info */}
                <p className="text-xs text-gray-500">
                  {footerText}
                </p>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-400">
          <Trophy className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
          <p>No cup matches yet</p>
        </div>
      )}
    </div>
  </div>
  );
};

export default CupProgressWidget;
